
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, update } from "store/group-user";
import { AppMessage } from "components";

interface ApiGroupUserUpdateInputProps extends GroupUserItemProps {
}

type ApiGroupUserUpdateOutputProps = OutputBaseProps<{ item: GroupUserItemProps; }, ApiGroupUserUpdateInputProps>

export const apiGroupUserUpdate = async (data: ApiGroupUserUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiGroupUserUpdateOutputProps>("/api/group/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};